// extracted by mini-css-extract-plugin
module.exports = {"avatar":"_3GCePY7yJTYY6LYVneJwK2","image":"_1H3TPIYT-e4SUPYXJ1knMq","letter":"_34Q66wtMr1f3IeYKg19K0w"};